const school = {
    title: 'विद्यालय',
    schoolName: 'विद्यालयको नाम',
    address: 'ठेगाना',
    province: 'प्रदेश',
    district: 'जिल्ला',
    save: 'सेभ गर्नुहोस्',
    cancel: 'रद्द गर्नुहोस्',
    addSchool: 'विद्यालय थप्नुहोस्',
    dob: 'जन्म मिति',
    IEMISNumber: 'आईईएमआईएस नम्बर',
    schoolsList: 'विद्यालय सूची',
    selectProvince: 'प्रदेश छान्नुहोस्',
    selectDistrict: 'जिल्ला छान्नुहोस्',
    search: 'विद्यालय खोज्नुहोस्...',
    studentsAtSchool: 'यस विद्यालयका विद्यार्थीहरू',
    noStudents: 'विद्यार्थी भेटिएन',
    viewProfile: 'हेर्नुहोस्',
    studentsCount: 'विद्यार्थी संख्या',
};
export default school;
